import { IMG_CDN_URL } from "../utils/constants";

const RestaurantCard = ({
  name,
  avgRating,
  sla,
  cuisines,
  areaName,
  cloudinaryImageId,
}) => {
  return (
    <div className="restaurant-card h-full flex flex-col justify-star hover:scale-95 transition-all duration-300 ease-in-out w-full">
      <div className="relativ">
        <img
          src={IMG_CDN_URL + cloudinaryImageId}
          alt="Restaurant Image"
          className="restaurant-image max-w-72 w-full object-cover h-48 rounded-xl drop-shadow-xl/25 "
        />
      </div>
      <div className="flex flex-col p-2">
        <h3 className="font-bold text-lg">
          {name
            ? name?.split(" ").slice(0, 3).join(" ") +
              (name?.split(" ").length > 3 ? "..." : "")
            : "Unknown"}
        </h3>
        <div className="rating-time flex space-x-1 align-middle items-center">
          {avgRating && (
            <>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
                strokecolor="rgba(2, 6, 12, 0.92)"
                fillcolor="rgba(2, 6, 12, 0.92)"
              >
                <circle
                  cx="10"
                  cy="10"
                  r="9"
                  fill="url(#StoreRating20_svg__paint0_linear_32982_71567)"
                ></circle>
                <path
                  d="M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z"
                  fill="white"
                ></path>
                <defs>
                  <linearGradient
                    id="StoreRating20_svg__paint0_linear_32982_71567"
                    x1="10"
                    y1="1"
                    x2="10"
                    y2="19"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#21973B"></stop>
                    <stop offset="1" stopColor="#128540"></stop>
                  </linearGradient>
                </defs>
              </svg>
              <span className="font-semibold">{avgRating + " - "}</span>
            </>
          )}
          <span className="font-semibold">{sla?.slaString}</span>
        </div>
        <p className="font-semibold text-gray-500 text-sm">
          {cuisines?.slice(0, 3).join(", ") +
            (cuisines?.length > 3 ? "..." : "")}
        </p>
        <p className="font-semibold text-gray-500 text-sm">{areaName}</p>
      </div>
    </div>
  );
};

export const withVegLabel = (RestaurantCard) => {
  return (props) => {
    return (
      <div className="relative grow">
        <label className="px-3 p-1 absolute z-10 md:bottom-36 left-1/3 -translate-y-1/6 md:translate-y-1/6 bottom-40 d:left-25 rounded-2xl font-semibold text-green-500 bg-black opacity-75">
          Pure Veg
        </label>
        <RestaurantCard {...props} />
      </div>
    );
  };
};

export default RestaurantCard;
